import React, {PureComponent}from 'react';
import axios from 'axios';
import  moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import './appointmentStyle.css';
import { Button, Modal } from 'react-bootstrap';


class AppoinementLists extends PureComponent {
	 
	constructor() {
		super();
		this.state = {
			appointmentLists:[],			
			//header:{headers: {'Content-Type': 'application/json','AccessToken': "163038842742107743a01d4314736a21efad433a60bdd"}},//worksite"
			header:{headers: {'Content-Type': 'application/json','AccessToken': "162998106222718c4e41373664cb6a48863115706cabc"}},//"Test admin
			//companyId:"6115f04a1131cd68d013ee93",//worksite
			companyId:"5a687382734d1d7c67982eee",//test
			baseURL:"https://app.pacifyr.net/pacifyr/v1/",
			showConfirmCancel:false,
			providerName :"",
			timeSlotId:"",
			userId:"599c40b63b105d08dbb523fc",
			showResMsg:"",
			showResModal:false,
			
		};/* 
		this.showConfirmPopup = this.showConfirmPopup.bind(this); */
	}
	async getAllAppoinmentList(){
		var _api =  this.state.baseURL+  "schedule/user/"+this.state.userId+"/bookings?limit=50&skip=0"
		var _responseData = await axios.get(_api, this.state.header);
		await this.setState({
			appointmentLists:_responseData.data.results,
		})
	}
	async handleCloseModal(){
		this.setState({			
			showConfirmCancel:false,
			showResModal:false
		});
	}
	async showConfirmPopup(timeSlotId, providerName){
		console.log(this.state.showConfirmCancel);
		await this.setState({			
			showConfirmCancel:true,
			providerName:providerName,
			timeSlotId:timeSlotId
		});
		console.log("After : ",this.state.showConfirmCancel);
	}
	async cancelAppoinment(){
		var _postObject = {	userId:this.state.userId};
		var _api = this.state.baseURL + "schedule/slots/book/cancel/"+this.state.timeSlotId;
		var _responseData = await axios.post(_api, _postObject,this.state.header);
		console.log(_responseData);
		if(_responseData.data.status === "success"){
			await this.setState({
				showResMsg:"Appointment cancelled successfully",
				showResModal:true,
				showConfirmCancel:false
			})
		}else{
			await this.setState({					
				showConfirmCancel:false,
				showResMsg:_responseData.data.message,
				showResModal:true,
			})
		}
	}
	componentDidMount() {
		 this.getAllAppoinmentList();
	}
	render() {
		return(
		<div className="row">
			<div className="col-sm-12 col-md-12" style={{padding:"0px"}}>
				<h1 className="headerappntmnt">Appointment</h1>
				<div className="appointtable appnttablehdr">
					<div className="">
						<span className="hdrspn datespn">Date</span>
						<span className="hdrspn timespn">Time</span>
						<span className="hdrspn cusprvidespn">Customer Name</span>
						<span className="hdrspn cusprvidespn">Provider Name</span>
						<span className="hdrspn notespn">Notes</span>
						<span className="hdrspn toolspn">Status</span>
						<div style={{clear:"both"}}></div>
					</div>
					{ this.state.appointmentLists.map((appointData, i) =>
						(
							<div key={i} className={(i%2 === 0 )?"bodytable activetable":"bodytable"}>
								<span className="hdrspn datespn">{moment(appointData.startTimeGMT).format("DD/MM/YYYY")}</span>
								<span className="hdrspn timespn">{moment(appointData.startTimeGMT).format("h:mm A")}</span>
								<span className="hdrspn cusprvidespn">-</span>
								<span className="hdrspn cusprvidespn" style={{color:"#1d8fdc"}}>{appointData.pacifyr.firstName+" "+appointData.pacifyr.lastName}</span>
								<span className="hdrspn notespn" >{appointData.statusText}</span>
								<span className="hdrspn toolspn">
									{(appointData.cancelled)?(<span style={{color:"red"}} > Cancelled </span>):(null)}
									{(appointData.rejected)?(<span style={{color:"red"}}> Rejected </span>):(null)}
									{( !appointData.cancelled && !appointData.rejected && appointData.confirmed && new Date(appointData.startTimeGMT) >= new Date())?(
										<span className="bookanappntmnt"onClick={e=>{this.showConfirmPopup(appointData.timeSlotId, appointData.pacifyr.firstName+" "+appointData.pacifyr.lastName)}}  style={{width: "10%"}}>Cancel</span>
									):(null) }
								</span>
								<div style={{clear:"both"}}></div>
							</div>
						)
					)}					
				</div>
				<Modal show={this.state.showConfirmCancel} onHide={()=>this.handleCloseModal()} animation={false}>
					<Modal.Header closeButton>
						<Modal.Title>Confirm</Modal.Title>
					</Modal.Header>
					<Modal.Body>Are you sure to cancel the appoinment with {this.state.providerName}</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={()=>this.handleCloseModal()}>No</Button>
						<Button variant="primary" onClick={()=>this.cancelAppoinment()}>YES</Button>
					</Modal.Footer>
				</Modal>
				<Modal show={this.state.showResModal} onHide={()=>this.handleCloseModal()} animation={false}>
					<Modal.Header closeButton>
						<Modal.Title>Message</Modal.Title>
					</Modal.Header>
					<Modal.Body>{this.state.showResMsg}</Modal.Body>
					<Modal.Footer>
						<Button variant="primary" onClick={()=>this.handleCloseModal()}>ok</Button>
					</Modal.Footer>
				</Modal>
				
				
			</div>
		</div>
		);
	}
}
  export default AppoinementLists;